import axios from "../../config/interceptor";

export const postOnboarding = async (data) => {
  try {
    const response = await axios.post(`/lambda/v1/onboarding`, data);

    return response;
  } catch (error) {
    return error;
  }
};
